"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Hidden;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Hidden(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "hidden"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M91.113,35.356a2.5,2.5,0,0,0-3.352,1.126A41.932,41.932,0,0,1,50,59.905a42.836,42.836,0,0,1-5.956-.414L91.768,11.768a2.5,2.5,0,0,0-3.536-3.536L38.218,58.247A41.935,41.935,0,0,1,12.239,36.482a2.5,2.5,0,0,0-4.478,2.226,46.937,46.937,0,0,0,26.48,23.515L8.232,88.232a2.5,2.5,0,0,0,3.536,3.536L39.744,63.791A47.71,47.71,0,0,0,50,64.905a46.906,46.906,0,0,0,42.239-26.2A2.5,2.5,0,0,0,91.113,35.356Z"
  }))));
}